module.exports = __webpack_public_path__ + "media/images/clients/padlock-lock-c85b36367d307b3994201755690b4087.svg";